
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from '@/store'

export default defineComponent({
  name: 'AppMain',
  setup () {
    const store = useStore()
    // get currentRoute ，报错 getCurrentInstance 中不存在 ctx ，但是实际在 浏览器中能正确获取值
    // console.log(getCurrentInstance().ctx.$router.currentRoute.value, 1)
    const cachedViews = computed(() => store.state.tagsView.cachedViews)
    const key = computed(() => useRoute().path)
    return {
      key,
      cachedViews
    }
  }
})
